import Vue from "vue";

Vue.component("ModalLots", () => import("./ModalLots.vue"));
